import { useEffect, useState } from "react";
import Icons from "../../../components/icons";
import { useAppServices } from "../../../hook/services";

const AuthTopBar = () => {
  const [agency, setAgency] = useState(null);
  const Service = useAppServices();
  const getting_whitelable_domain = async () => {
    const currentURL = window.location.href;
    const urlObject = new URL(currentURL);
    const domain = urlObject.hostname;
    const payload = {
      domain: domain,
    };
    const { response } = await Service.agency.getwhitelabel({
      payload: payload,
    });
    const { response: agency_response } = await Service.agency.getAgency({
      query: `_id=${response?.data?._id}`,
    });
    if (agency_response?.data) {
      setAgency(agency_response?.data);
    }
  };

  useEffect(() => {
    getting_whitelable_domain();
  }, []);
  return (
    <div className="w-full py-4 px-3 bg-white border-b">
      {agency?.Customization?.logo ? (
        <img
          src={agency?.Customization?.logo}
          alt="logo"
          style={{ maxWidth: "98px", maxHeight: "28px", paddingLeft: "10px" }}
        />
      ) : (
        <Icons id="maybeIcon" />
      )}
    </div>
  );
};

export default AuthTopBar;
